import { useUnclassifiedIntakeCount } from '@/hooks/useIntakeRequests';

/** Contador de não classificadas no item "Central de Solicitações" do menu. */
export function UnclassifiedIntakeBadge({ enabled }: { enabled: boolean }) {
  const { data } = useUnclassifiedIntakeCount(enabled);
  const count = data?.count ?? 0;
  if (!enabled || count === 0) return null;
  return (
    <span
      aria-label={`${count} solicitações não classificadas`}
      className="ml-auto rounded-full bg-amber-500 px-2 py-0.5 text-xs font-semibold text-white"
    >
      {count > 99 ? '99+' : count}
    </span>
  );
}
